import { render, staticRenderFns } from "./PaginateButtonsShrinkingBin.vue?vue&type=template&id=35a15213&scoped=true&"
import script from "./PaginateButtonsShrinkingBin.vue?vue&type=script&lang=ts&"
export * from "./PaginateButtonsShrinkingBin.vue?vue&type=script&lang=ts&"
import style0 from "./PaginateButtonsShrinkingBin.vue?vue&type=style&index=0&id=35a15213&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a15213",
  null
  
)

export default component.exports